import React from 'react';
import LegalPage from './LegalPage';
import LegalDocument from '../../legal/LegalDocument';
import { CONSENT } from '../../legal/documents';

const PersonalDataConsent: React.FC = () => (
  <LegalPage title="Согласие на обработку персональных данных">
    <LegalDocument nodes={CONSENT} />
  </LegalPage>
);

export default PersonalDataConsent;
